//Main landing page for TCS
import React, { useRef } from "react";
import styled from "styled-components";
import { getTheme } from "Theme";
import BannerLogo from "../../assets/logos/banner.png";
import FIVE3v3rLogo from "../../assets/marketing/five3v3r_logo.svg";
import ToneDevsLogo from "../../assets/marketing/tonedevs-logo-temp.png";
import HotelSolutionsLogo from "../../assets/marketing/hotelsolutions-logo.png";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Background from "../../assets/background.png";
import moment from "moment";
import { ReactComponent as Up } from "../../assets/upArrow.svg";
import { Button, Column, Row } from "globalComponents";
import DemoImageBilling from "../../assets/marketing/screenshot-billing-view.png";
import cookie from "js-cookie";

const theme = getTheme();
const Main = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${theme.PAGE_BACKGROUND};
`;

const Logo = styled.img`
  width: 100px;
  height: auto;
  cursor: pointer;
`;
const NavBar = styled.div`
  height: 40px;
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
  justify-content: space-between;
  gap: 5%;
  margin-top: 2vh;
  align-items: center;
`;

const NavigationContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10%;
  align-items: center;
  justify-content: flex-start;
`;

const NavbarLink = styled.div`
  color: white;
  font-size: 1.3em;
  font-weight: 700;
  cursor: pointer;
  :hover {
    font-weight: 900;
    opacity: 0.8;
  }
  @media (max-width: 900px) {
    display: none;
  }
`;

const DashboardButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  background-color: white;
  border-radius: 25px;

  width: fit-content;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  box-shadow: -2px 3px #252525;
  :hover {
    background-color: ${theme.BUTTON_COLOR};
    transition: transform 0.2s;
    transform: translateX(10px);
  }
  @media (max-width: 900px) {
    font-size: 12px;
  }
`;
const Arrow = styled(Up)`
  width: 10px;
  height: 10px;
  transform: rotate(90deg);
`;
const Header = styled.div`
  display: flex;
  flex-direction: column;
  height: 60vh;
  min-height: fit-content;
  background-image: url(${Background});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const HeaderCard = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 550px;
  min-width: 200px;
  gap: 40px;
  color: white;
  margin: 6% 0 6% 0;
  @media (max-width: 1300px) {
    padding: 0 5% 0 5%;
  }
`;

const HeaderTitle = styled.div`
  font-weight: 900;
  font-size: 6em;
  line-height: 90%;

  @media (max-width: 900px) {
    font-size: 3em;
  }
`;

const HeaderParagraph = styled.div`
  font-size: 30px;
  font-weight: 600;
  word-spacing: 3px;
  line-height: 100%;
  color: black;
  @media (max-width: 900px) {
    font-size: 1.5em;
  }
`;

const BreakpointContainer = styled.div`
  max-width: 1080px;
  width: 100%;
  margin: 0 auto 0 auto;
`;
const DemoSection = styled(BreakpointContainer)`
  display: flex;
  flex-direction: row;
  background-color: ${theme.PAGE_BACKGROUND};
  width: 100vw;
  padding-bottom: 150px;
  @media (max-width: 1300px) {
    padding-bottom: 0px;
  }
`;
const Section = styled(BreakpointContainer)`
  display: flex;
  flex-direction: row;
  width: 100vw;
  min-height: 40vh;
  padding: 5% 0%;
  padding-bottom: 14%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 50%;

  @media (max-width: 1300px) {
    width: 100%;
    padding: 0 5% 0 5%;
  }
`;

const ContentHeader = styled.div`
  font-weight: 900;
  font-size: 4em;
  line-height: 80%;
  color: ${theme.MAIN_COLOR};
  line-height: 120%;
  @media (max-width: 900px) {
    font-size: 2.5em;
  }
`;

const ContentDescription = styled.div`
  font-size: 1.4em;
  font-weight: 600;
  line-height: 140%;
  @media (max-width: 900px) {
    font-size: 1.2em;
  }
`;

const CustomerRow = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10% 0;
  width: 100vw;
  @media (max-width: 900px) {
  }
`;

const CustomerLogo = styled.img`
  width: 150px;
  height: auto;
  @media (max-width: 900px) {
    width: 100px;
  }
`;

const CTARow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10%;
  padding: 0 5% 0 5%;
`;
const CTAButton = styled(Button)`
  height: 60px;
  width: 300px;
  font-size: 1.5em;
  font-weight: 700;
`;

const DemoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: sticky;
  border: 8px solid #1f1c1ddd;
  border-radius: 10px;
  top: 50%;
  height: fit-content;
  margin-top: 20%;
  right: 0px;
  transform: translate(-45%, -52%);
  @media (max-width: 1300px) {
    display: none;
  }
`;

const DemoImage = styled.img`
  width: 400px;
  height: auto;
  border-radius: 5px;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 20vh;
  background-color: ${theme.MAIN_COLOR};
  padding: 5%;
`;
const Banner = styled.img`
  cursor: pointer;
  height: auto;
  width: 10vw;
  min-width: 150px;
  margin-bottom: 10px;

  @media (max-width: 900px) {
    min-width: 100px;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  height: 15vh;
`;

const InfoTitle = styled.div`
  font-size: 2em;
  font-weight: bold;
  color: white;
  margin-bottom: 30px;
  @media (max-width: 900px) {
    font-size: 1.5em;
    margin-bottom: 10px;
  }
`;

const Info = styled.div`
  font-size: 1.2em;
  font-weight: 500;
  color: ${theme.TEXT};
  padding-bottom: 5px;
  @media (max-width: 900px) {
    font-size: 1em;
  }
`;
const InfoLink = styled.a`
  font-size: 1.2em;
  color: ${theme.TEXT};
  padding-bottom: 5px;
  @media (max-width: 900px) {
    font-size: 1em;
  }
`;

const NotificationBar = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(96, 255, 175, 0.95); /* pastel blue with transparency */
  color: #222;
  font-weight: bold;
  font-size: 1.2em;
  padding: 18px 40px 18px 20px;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  /* Slide in animation */
  animation: slideDown 0.5s cubic-bezier(0.4, 0, 0.2, 1);

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const NotificationDismissButton = styled.button`
  background: #fff;
  border: 2px solid ${theme.MAIN_COLOR};
  font-size: 2em;
  cursor: pointer;
  color: ${theme.MAIN_COLOR};
  margin-left: 30px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(5, 228, 91, 0.15);
  transition:
    background 0.2s,
    color 0.2s,
    transform 0.2s;
  &:hover {
    background: #05e45b;
    color: #fff;
    transform: scale(1.1);
  }
`;
const Home = () => {
  const history = useHistory();
  const productRef = useRef(null);
  const integrationsRef = useRef(null);
  const legalRef = useRef(null);
  const [showNotification, setShowNotification] = React.useState(false);

  const dismissedUpdateNotification = cookie.get("dismissedUpdateNotification");

  React.useEffect(() => {
    if (!dismissedUpdateNotification) {
      const timer = setTimeout(() => setShowNotification(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      <Main>
        <Header>
          {showNotification && (
            <NotificationBar>
              <span>
                We've Made some changes! Click "Go To Dashboard" to login to
                TCS.
              </span>
              <NotificationDismissButton
                aria-label="Dismiss notification"
                onClick={() => {
                  cookie.set("dismissedUpdateNotification", "true", {
                    expires: 365,
                  });
                  setShowNotification(false);
                }}
              >
                ×
              </NotificationDismissButton>
            </NotificationBar>
          )}
          <BreakpointContainer>
            <NavBar>
              <NavigationContainer>
                <Logo src="/tcs.svg" alt="" onClick={() => history.push("/")} />
                <NavbarLink
                  onClick={() =>
                    productRef.current.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    })
                  }
                >
                  Product
                </NavbarLink>
                <NavbarLink
                  onClick={() =>
                    integrationsRef.current.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    })
                  }
                >
                  Integrations
                </NavbarLink>
                <NavbarLink
                  onClick={() =>
                    legalRef.current.scrollIntoView({
                      behavior: "smooth",
                    })
                  }
                >
                  Legal
                </NavbarLink>
              </NavigationContainer>
              <DashboardButton onClick={() => history.push("/login")}>
                Go to Dashboard
                <Arrow />
              </DashboardButton>
            </NavBar>
            <HeaderCard>
              <HeaderTitle>Manage Your Staff From Anywhere</HeaderTitle>
              <HeaderParagraph>
                Manage, bill, and track your staffing operations from anywhere.
                Seamlessly integrated into your existing workflow.
              </HeaderParagraph>
            </HeaderCard>
          </BreakpointContainer>
        </Header>
        <CustomerRow>
          <a href="https://five3v3r.com">
            <CustomerLogo src={FIVE3v3rLogo} alt="FIVE3v3r" />
          </a>
          <a href="https://hotelsolutionscorp.com">
            <CustomerLogo src={HotelSolutionsLogo} alt="Hotel Solutions" />
          </a>
          <a href="https://tonedevs.com">
            <CustomerLogo src={ToneDevsLogo} alt="tonedevs" />
          </a>
        </CustomerRow>
        <CTARow>
          <CTAButton
            style={{ background: "#05E45B" }}
            onClick={() => history.push("/onboarding/root")}
          >
            Get Started
          </CTAButton>
          <CTAButton onClick={() => history.push("/contact")}>
            Contact Us
          </CTAButton>
        </CTARow>
        <DemoSection>
          <Column>
            <Section ref={productRef}>
              <Content>
                <ContentHeader>
                  Custom Solution Without The Custom Price
                </ContentHeader>
                <ContentDescription>
                  TCS delivers customizeable solutions capable of meeting all
                  your companies specific staffing management needs. No matter
                  how complex your billing, client and employee management needs
                  are TCS is the tool for you.
                  <br />
                  <br />
                  <i style={{ color: theme.MAIN_COLOR }}>
                    TCS doesn't meet your needs?
                  </i>
                  <br /> Any missing features your company needs can be added at
                  no extra cost!
                </ContentDescription>
              </Content>
            </Section>
            <Section ref={integrationsRef}>
              <Content>
                <ContentHeader>Seamless Integrations</ContentHeader>
                <ContentDescription>
                  TCS makes it easy to import and export employee and financial
                  data giving you complete access to all your stored data at the
                  click of a button.
                  <br />
                  <br />
                  <i style={{ color: theme.MAIN_COLOR }}>Need more?</i>
                  <br /> Let us know what software integrations you'd like us to
                  add next!
                </ContentDescription>
              </Content>
            </Section>
            <Section ref={legalRef}>
              <Content>
                <ContentHeader>Safe and Sound</ContentHeader>
                <ContentDescription>
                  Keep your business protected with manager and employee safety
                  features preventing mistakes that can cost you big. TCS
                  provides full control over what every employee and manager has
                  access to. With fully custom permission groups management
                  mishaps are a thing of the past.
                  <br />
                  <br />
                  Plus with our{" "}
                  <b style={{ color: theme.SUCCESS }}>
                    Secure Client Billing
                  </b>{" "}
                  and hours management, you'll be able to satisfy even the
                  neediest of customers.
                </ContentDescription>
              </Content>
            </Section>
          </Column>
          <DemoContainer>
            <DemoImage src={DemoImageBilling} alt="Demo" />
          </DemoContainer>
        </DemoSection>
        <Footer>
          <BreakpointContainer>
            <Row>
              <FooterSection>
                <Banner
                  src={BannerLogo}
                  alt="logo"
                  onClick={() => history.push("/")}
                />
                <Info>321 W Winnie Lane #104</Info>
                <Info>Carson City, NV 89703</Info>
              </FooterSection>
              <Row style={{ marginLeft: "auto", gap: "40px" }}>
                <FooterSection>
                  <InfoTitle>Legal</InfoTitle>
                  <InfoLink href="/privacy">Privacy Policy</InfoLink>
                  <InfoLink href="/terms"> Terms and Conditions</InfoLink>
                  <InfoLink href="/cookies">Cookie Policy</InfoLink>
                  <InfoLink href="/messaging">Messaging</InfoLink>
                </FooterSection>
                <FooterSection>
                  <InfoTitle>Questions?</InfoTitle>
                  <InfoLink href="/faq">FAQ</InfoLink>
                  <InfoLink href="/contact">Contact Us</InfoLink>
                </FooterSection>
              </Row>
            </Row>
            <Info style={{ fontWeight: "700" }}>
              © {moment().format("yyyy")} Time Card Solutions LLC
            </Info>
          </BreakpointContainer>
        </Footer>
      </Main>
    </>
  );
};
export default Home;
